module.exports = __webpack_public_path__ + "c0f64b2c59c5b43f2bb5188f1f87f8d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/yu.jpg
// module id = 589
// module chunks = 30